import { isArray } from 'util';
import { Operation } from '../operation';
import { parseNumber } from '../../utils/number.utils';
import { OperationModeBuilder } from './operation-mode.builder';

export class OperationBuilder {
  static fromJson(json) {
    return (json)
      ? new Operation(
        json.hash,
        json.name,
        parseNumber(json.index),
        OperationModeBuilder.fromJson(json.mode),
        json.active,
        json.modeName
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OperationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operation.builder.ts